import { DepartmentIcon } from "@whoosh/design-system/src/components/icons_v2/department/components/DepartmentIcon";
import {
  Box,
  HStack,
  Text,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

import { ScheduleOption } from "./hooks/useGetScheduleSwitcherOptions";

type Props = {
  option: ScheduleOption;
  onPress: (option: ScheduleOption) => void;
  selected?: boolean;
  icon?: React.JSX.Element;
  isOpen?: boolean;
  testID?: string;
  accessibilityLabel?: string;
};

export const ScheduleSwitcherOption = ({
  option,
  icon,
  onPress,
  selected,
  isOpen,
  testID,
  accessibilityLabel,
}: Props) => {
  const iconBg = selected ? "surface-secondary" : "transparent";

  return (
    <Pressable
      _hover={{
        backgroundColor: !selected ? "surface-secondary" : undefined,
        borderColor: selected ? "grayscale-700" : undefined,
      }}
      onPress={() => onPress(option)}
      borderRadius="2"
      justifyContent="space-between"
      gap={3}
      alignItems="center"
      flexDirection="row"
      borderColor={isOpen ? "grayscale-1000" : "surface-dividers"}
      borderWidth={selected ? 1.5 : 0}
      testID={testID}
      accessibilityLabel={accessibilityLabel}
    >
      <HStack
        alignItems="center"
        gap={3}
        justifyContent="flex-start"
        borderBottomLeftRadius="2"
        borderTopLeftRadius="2"
      >
        <Box
          alignItems="center"
          justifyContent="center"
          backgroundColor={iconBg}
          borderBottomLeftRadius="2"
          borderTopLeftRadius="2"
          width={48}
          height={48}
          borderRightWidth={selected ? 1.5 : 0}
          borderRightColor="surface-dividers"
        >
          <DepartmentIcon type={option.departmentType} />
        </Box>
        <Text variant="mainBaseSemiBold">{option.label}</Text>
      </HStack>
      <Box pr={4} borderBottomRightRadius="2" borderTopRightRadius="2">
        {icon}
      </Box>
    </Pressable>
  );
};
